import {
  MILL_PROGRESS,
  MILL_MAP_PROGRESS,
  GET_MILLS,
  SELECT_MILL,
  SET_FILTER,
  IS_PDF,
  IS_IN_EXTENT,
} from "../actions/types";

const initialState = {
  mills: {},
  progress: true,
  progressMap: true,
  selected: {},
  pdf: false,
  inExtent: null,
  filter: {
    municipality: [],
    propulsion: [],
    exists: [],
    time: [],
  },
};

// eslint-disable-next-line
export default function (state = initialState, action) {
  switch (action.type) {
    case MILL_PROGRESS:
      return {
        ...state,
        progress: !state.progress,
      };
    case MILL_MAP_PROGRESS:
      return {
        ...state,
        progressMap: !state.progressMap,
      };
    case GET_MILLS:
      return {
        ...state,
        mills: action.payload,
      };
    case SELECT_MILL:
      return {
        ...state,
        selected: action.payload.selected,
      };
    case SET_FILTER:
      return {
        ...state,
        filter: action.payload,
      };
    case IS_PDF:
      return {
        ...state,
        pdf: action.payload,
      };
    case IS_IN_EXTENT:
      return {
        ...state,
        inExtent: action.payload,
      };
    default:
      return state;
  }
}
